import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export default function getCurrentCountrySite() {
  return publicRuntimeConfig.country || 'EN';
}

export function isAustralianSite() {
  return getCurrentCountrySite() === 'AU';
}
